import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';
import {DialogContent, DialogHeader} from 'components/ui-kit/Modal/styled';
import {Textarea} from 'components/ui-kit/Textarea';
import {border, colors, font} from 'theme';

export const StyledModal = styled(Modal)`
    ${DialogHeader} {
        margin-bottom: 0;
        padding: 16px 48px 16px 24px;
        text-align: left;
        border-bottom: 1px solid #ededed;
    }

    ${DialogContent} {
        &[data-reach-dialog-content] {
            width: min(100vw - 30px, 600px);
            max-width: min(100vw - 30px, 600px);
            padding: 0;
            overflow: visible;
            border-radius: 12px;
            box-shadow: 0 12px 32px rgba(52, 52, 52, 0.16);
        }
    }
`;

export const TitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Title = styled.h2`
    margin: 0;
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 20px;
    font-weight: 600;
    line-height: 19px;
`;

export const Subtitle = styled.p`
    margin: 0;
    color: ${colors.textSecondary};
    font-family: ${font.family.primary};
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px 24px;
`;

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 20px 24px;
    border-top: 1px solid #ededed;
`;

export const FooterButton = styled(Button)`
    width: auto;
`;

export const CommentField = styled(Textarea)`
    textarea {
        height: 88px;
        border-radius: ${border.radius};
    }
`;
